/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DeploymentStatesEnum = 'IN_PROGRESS' | 'READY' | 'FAILED' | 'DELETION_REQUESTED' | 'DELETING' | 'DELETION_WAITING_APPROVAL' | 'DELETION_FAILED' | 'DELETED';

export const DeploymentStatesEnum = {

    IN_PROGRESS: 'IN_PROGRESS' as DeploymentStatesEnum,

    READY: 'READY' as DeploymentStatesEnum,

    FAILED: 'FAILED' as DeploymentStatesEnum,

    DELETION_REQUESTED: 'DELETION_REQUESTED' as DeploymentStatesEnum,

    DELETING: 'DELETING' as DeploymentStatesEnum,

    DELETION_WAITING_APPROVAL: 'DELETION_WAITING_APPROVAL' as DeploymentStatesEnum,

    DELETION_FAILED: 'DELETION_FAILED' as DeploymentStatesEnum,

    DELETED: 'DELETED' as DeploymentStatesEnum
};

